import { config } from '../../shared/config';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
  export class tmAuthConfig
 {
    public clientId? ='d535bb7d3584.fortress.integ3-sandbox.us';
    public authUri? = 'https://auth.ticketmaster.com/archtics/sign-in';
    public authRedirectUri? = config.portalUrl + '/tm-auth-callback';
    public loginUri? = 'https://am.ticketmaster.com/padres/sso';
    public signOutUri? = 'https://auth.ticketmaster.com/archtics/sign-out';
    public visualPresents? = 'LAFC.android.sdk';
    public integratorId? = 'fortress';
    public placementId? = 'homepage';
    public scope? = 'openid profile archtics';
 }